import { osHref } from "@/lib/os-href";

export function hasProfessionalDesk(input: {
  isAgent?: boolean;
  grants?: Array<{ status: string }> | null;
}) {
  if (input.isAgent) return true;
  return Boolean(input.grants?.some((grant) => grant.status === "ACTIVE"));
}

export function professionalChatHref(
  handle: string,
  conversationId?: number,
) {
  const href = osHref({ type: "personal", handle }, "/conversations");
  return conversationId ? `${href}?thread=chat:${conversationId}` : href;
}

export function professionalListingsHref(handle: string) {
  return osHref({ type: "personal", handle }, "/inventory");
}

export function marketplaceChatConversationId(pathname: string): number | null {
  const match = pathname.match(/^\/chat\/(\d+)(?:\/|$)/);
  if (!match) return null;
  const id = Number.parseInt(match[1] ?? "", 10);
  return Number.isFinite(id) ? id : null;
}

export function professionalOsHref(handle: string | null | undefined) {
  const trimmed = handle?.trim();
  return trimmed ? osHref({ type: "personal", handle: trimmed }, "/dashboard") : "/os";
}

export function professionalDeskHrefs(input: {
  isProfessional: boolean;
  handle?: string | null;
}) {
  const handle = input.handle?.trim() || null;
  if (!input.isProfessional) {
    return {
      chatHref: "/chat",
      listingsHref: "/my-listings",
      osHref: professionalOsHref(handle),
    };
  }
  return {
    chatHref: handle ? professionalChatHref(handle) : "/os",
    listingsHref: handle ? professionalListingsHref(handle) : "/os",
    osHref: professionalOsHref(handle),
  };
}
